import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import moment from 'moment';

import * as HrActions from '../../../store/actions/hr.action';
import { getHrState } from '../../../store/selector/hr.selector';
import DynamicCrumbs from '../../../shared/components/ui/dashboard-layout/dynamic-crumbs';
import DynamicTabLink from '../../../shared/components/ui/dynamic-tabs/dynamic-tab-link';
import { HR_TABS_CONSTANT } from '../../../shared/constants/hr-tabs.constant';

const styles = {
  header: {
    display: 'flex',
    flexDirection: { sm: 'row', xs: 'column' },
    justifyContent: 'space-between',
    alignItems: { sm: 'center', xs: 'flex-start' },
    mb: 3,
  },
};

const HrAuditTrail = () => {
  const dispatch = useDispatch();
  const { slug } = useParams<string>();
  const {
    selected: { application, history },
  } = useSelector(getHrState);

  useEffect(() => {
    if (slug) dispatch(HrActions.HrFetchApplication(slug));
  }, []);

  return (
    <>
      <Box sx={styles.header}>
        <Box>
          <DynamicCrumbs />
          <Typography sx={{ fontSize: '1.5rem' }}>
            {application?.lastname}, {application?.firstname}, {application?.middlename} -{' '}
            {application?.code}
          </Typography>
        </Box>
      </Box>

      <DynamicTabLink tabs={HR_TABS_CONSTANT} />

      {history && (
        <Box sx={{ my: 4 }}>
          <VerticalTimeline>
            {history.map((item: any, index: number) => (
              <VerticalTimelineElement
                key={item.date}
                className='vertical-timeline-element--action'
                date={moment(item.date).format('MMMM Do YYYY, h:mm:ss a')}
                contentStyle={{
                  background: index === 0 ? 'rgb(2 0 77)' : '#fff',
                  color: index === 0 ? '#fff' : '',
                }}
                contentArrowStyle={{
                  borderRightWidth: '7px',
                  borderRightStyle: 'solid',
                  borderRightColor: index === 0 ? 'rgb(2 0 77)' : '#fff',
                }}
                iconStyle={{
                  background: index === 0 ? 'rgb(2 0 77)' : 'rgb(202 202 202)',
                  color: '#fff',
                }}
                // icon={<SchoolIcon />}
              >
                <>
                  <Typography
                    className='vertical-timeline-element-title'
                    variant='h3'
                    sx={{
                      fontSize: '1.5rem',
                      textTransform: 'uppercase',
                      fontFamily: 'DMSansBlack',
                      wordBreak: 'break-word',
                    }}
                  >
                    {item.by}
                  </Typography>

                  <Typography
                    className='vertical-timeline-element-subtitle'
                    variant='h4'
                    sx={{
                      fontSize: '1rem',
                      textTransform: 'uppercase',
                      fontFamily: 'DMSansBlack',
                      marginY: 2,
                    }}
                  >
                    FROM
                  </Typography>

                  {Object.entries(item.from).map(([k, v]) => (
                    <Typography key={k} style={{ margin: 0, textTransform: 'capitalize' }}>
                      {`${k.replaceAll('_', ' ')} : ${v}`}
                    </Typography>
                  ))}

                  <Typography
                    className='vertical-timeline-element-subtitle'
                    variant='h4'
                    sx={{
                      fontSize: '1rem',
                      textTransform: 'uppercase',
                      fontFamily: 'DMSansBlack',
                      marginY: 2,
                    }}
                  >
                    TO
                  </Typography>

                  {Object.entries(item.to).map(([k, v]) => (
                    <Typography key={k} style={{ margin: 0, textTransform: 'capitalize' }}>
                      {`${k.replaceAll('_', ' ')} : ${v}`}
                    </Typography>
                  ))}
                </>
              </VerticalTimelineElement>
            ))}

            {/* <VerticalTimelineElement
              iconStyle={{ background: 'rgb(42 176 151)', color: '#fff' }}
              // icon={<StarIcon />}
            /> */}
          </VerticalTimeline>
        </Box>
      )}
    </>
  );
};
export default HrAuditTrail;

